/**
 * Whether onboarding should route to the post-onboarding camera check
 * (proactive-alerting report) for the integration picked in the wizard.
 *
 * actuate_admin serves `camera_check_supported` per integration on
 * `integration_type/onboarding/`, stored in localStorage as `integrationTypes`
 * by dataFetchers. The lookup is by `selectedIntegrationName` (the internal
 * name), never the display name, so renaming an integration in admin can't
 * change the wizard flow. Replaces the hardcoded `validIntegrationTypes` list
 * of display names (ENG-1919).
 *
 * Defaults to true when the flag is absent (older admin) or the integration
 * isn't found, so no integration is silently cut out of the check.
 */
export const isCameraCheckSupported = (
  integrationName: string | null | undefined = typeof localStorage !==
  "undefined"
    ? localStorage.getItem("selectedIntegrationName")
    : null,
  integrationTypesJson: string | null | undefined = typeof localStorage !==
  "undefined"
    ? localStorage.getItem("integrationTypes")
    : null
): boolean => {
  if (!integrationName || !integrationTypesJson) {
    return true;
  }
  let integrationTypes: unknown;
  try {
    integrationTypes = JSON.parse(integrationTypesJson);
  } catch {
    return true;
  }
  if (!Array.isArray(integrationTypes)) {
    return true;
  }
  const match = integrationTypes.find(
    (item: any) => item && item.name === integrationName
  );
  if (!match || typeof match.camera_check_supported !== "boolean") {
    return true;
  }
  return match.camera_check_supported;
};
